// extracted by mini-css-extract-plugin
export default {"container":"SideSheet_container__vxXKo","wrapper":"SideSheet_wrapper__4zgi2","content":"SideSheet_content__v72fn"};